import { Fragment, h } from 'preact';

export function handleSendCopyButtonsForNodes(props: any) {
    // let hideActionButtons = props?.msgData?.node?.template && props?.msgData?.node?.templateRender;
    return (
        <>
            {!props?.msgData?.rootServiceInstance?.hideActionButtons && (
                <div className={"send-copy-actions " + (props?.msgData?.addHideClass ? 'aa-hidden' : '')}>
                    {!props?.msgData?.rootServiceInstance?.hideCopyButton && (
                        <button className="aa-solidbtn aa-copy-btn-suggestion" aria-label="button">
                            <svg width="12" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_9531_13889)">
                                    <path d="M10.6663 10.6667V12.5333C10.6663 13.2801 10.6663 13.6534 10.521 13.9387C10.3932 14.1895 10.1892 14.3935 9.93833 14.5214C9.65311 14.6667 9.27974 14.6667 8.53301 14.6667H3.46634C2.7196 14.6667 2.34624 14.6667 2.06102 14.5214C1.81014 14.3935 1.60616 14.1895 1.47833 13.9387C1.33301 13.6534 1.33301 13.2801 1.33301 12.5333V7.46668C1.33301 6.71994 1.33301 6.34657 1.47833 6.06136C1.60616 5.81047 1.81014 5.6065 2.06102 5.47867C2.34624 5.33334 2.7196 5.33334 3.46634 5.33334H5.33301M7.46634 10.6667H12.533C13.2797 10.6667 13.6531 10.6667 13.9383 10.5214C14.1892 10.3935 14.3932 10.1895 14.521 9.93866C14.6663 9.65345 14.6663 9.28008 14.6663 8.53334V3.46668C14.6663 2.71994 14.6663 2.34657 14.521 2.06136C14.3932 1.81047 14.1892 1.6065 13.9383 1.47867C13.6531 1.33334 13.2797 1.33334 12.533 1.33334H7.46634C6.7196 1.33334 6.34624 1.33334 6.06102 1.47867C5.81014 1.6065 5.60616 1.81047 5.47833 2.06136C5.33301 2.34657 5.33301 2.71994 5.33301 3.46668V8.53334C5.33301 9.28008 5.33301 9.65345 5.47833 9.93866C5.60616 10.1895 5.81014 10.3935 6.06102 10.5214C6.34624 10.6667 6.7196 10.6667 7.46634 10.6667Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_9531_13889">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    )}
                    {!props?.msgData?.rootServiceInstance?.hideSendButton && (
                        <button className="aa-solidbtn aa-text-xs aa-send-btn-suggestion">{props?.hostInstance?.languagedata?.SEND}</button>
                    )}
                </div>
            )}
        </>
    )
}

export function handleSendCopyButtons(props: any) {
    return (
        <>
            {!props?.msgData?.rootServiceInstance?.hideActionButtons && (
                <div className={"action-buttons aa-action-buttons " + (props?.msgData?.addHideClass ? 'aa-hidden' : '')}>
                    {!props?.msgData?.rootServiceInstance?.hideCopyButton && (
                        <button className="aa-solidbtn aa-copy-btn-suggestion" aria-label="button">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_9506_130502)">
                                    <path d="M10.6663 10.6663V12.533C10.6663 13.2797 10.6663 13.6531 10.521 13.9383C10.3932 14.1892 10.1892 14.3932 9.93833 14.521C9.65311 14.6663 9.27974 14.6663 8.53301 14.6663H3.46634C2.7196 14.6663 2.34624 14.6663 2.06102 14.521C1.81014 14.3932 1.60616 14.1892 1.47833 13.9383C1.33301 13.6531 1.33301 13.2797 1.33301 12.533V7.46634C1.33301 6.7196 1.33301 6.34624 1.47833 6.06102C1.60616 5.81014 1.81014 5.60616 2.06102 5.47833C2.34624 5.33301 2.7196 5.33301 3.46634 5.33301H5.33301M7.46634 10.6663H12.533C13.2797 10.6663 13.6531 10.6663 13.9383 10.521C14.1892 10.3932 14.3932 10.1892 14.521 9.93833C14.6663 9.65311 14.6663 9.27974 14.6663 8.53301V3.46634C14.6663 2.7196 14.6663 2.34624 14.521 2.06102C14.3932 1.81014 14.1892 1.60616 13.9383 1.47833C13.6531 1.33301 13.2797 1.33301 12.533 1.33301H7.46634C6.7196 1.33301 6.34624 1.33301 6.06102 1.47833C5.81014 1.60616 5.60616 1.81014 5.47833 2.06102C5.33301 2.34624 5.33301 2.7196 5.33301 3.46634V8.53301C5.33301 9.27974 5.33301 9.65311 5.47833 9.93833C5.60616 10.1892 5.81014 10.3932 6.06102 10.521C6.34624 10.6663 6.7196 10.6663 7.46634 10.6663Z" stroke="#101828" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_9506_130502">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    )}
                    {!props?.msgData?.rootServiceInstance?.hideSendButton && (
                        <button className="aa-solidbtn aa-text-xxs aa-send-btn-suggestion" aria-label="button">
                            {props?.hostInstance?.languagedata?.SEND}
                        </button>
                    )}
                </div>
            )}
        </>
    )
}

export function ActionButtonsSentText(props: any) {
    return (
        <div className="aa-text-xs sent-msg-text aa-sent-text">
        </div>
    )
}

export function HandleViewMoreLessButtons(props: any) {
    return (
        <>
            {props?.msgData?.suggestionLength > 2 && (
                <div className="more-links-buttons">
                    <button className="more-link-text aa-text-xs aa-hidden aa-less-link" role="link">{props?.msgData?.showLessText}</button>
                    <button className="more-link-text aa-text-xs aa-more-link" role="link">{props?.msgData?.showMoreText}</button>
                </div>
            )}
        </>
    )
}

export function NoTabsScreen(props: any) {
    return (
        <div className="aa-no-tabs-screen">{props?.hostInstance?.languagedata?.TAB_TEXT}</div>
    )
}
